<template>
  <div class="faq">
    <Modal
      v-model="modalAdd"
      title="新增商品"
      :closable="false"
      :mask-closable="false"
      @on-ok="addRecord"
    >
      <p>类型：</p>
      <Select v-model="addClassify" filterable>
        <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <Input v-model="addQuestion" placeholder="问题" clearable /> -->
      <!-- <p>图片：</p>
      <Input type="textarea" :autosize="{minRows: 3}" v-model="addImages" placeholder="请输入图片名称，回车输入下一个" clearable/> -->
      <p>图片-商店-shop：{{shop_image_name}}</p>
      <Upload action="" :before-upload="addImageForShop" :multiple="true">
          <Button icon="ios-cloud-upload-outline">上传图片</Button>
      </Upload>
	  <p>图片-站着-stand：{{stand_image_name}}</p>
	  <Upload action="" :before-upload="addImageForStand" :multiple="true">
	      <Button icon="ios-cloud-upload-outline">上传图片</Button>
	  </Upload>
	  <p>图片-坐着-sit：{{sit_image_name}}</p>
	  <Upload action="" :before-upload="addImageForSit" :multiple="true">
	      <Button icon="ios-cloud-upload-outline">上传图片</Button>
	  </Upload>
	  <p>图片-躺着-个人self：{{lie_self_image_name}}</p>
	  <Upload action="" :before-upload="addImageForLieSelf" :multiple="true">
	      <Button icon="ios-cloud-upload-outline">上传图片</Button>
	  </Upload>
	  <p>图片-躺着-俯视-front：{{lie_front_image_name}}</p>
	  <Upload action="" :before-upload="addImageForLieFront" :multiple="true">
	      <Button icon="ios-cloud-upload-outline">上传图片</Button>
	  </Upload>
	  <p>性别：</p>
      <Select v-model="addSex" filterable>
        <Option v-for="item in filterSex.slice(0,2)" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <p>用钻价格：</p>
      <Input v-model="addJewelPrice" placeholder="请输入用钻价格" clearable />
      <p>用币价格：</p>
      <Input v-model="addCoinPrice" placeholder="请输入用币价格" clearable />
      <p>折扣：</p>
      <Select v-model="addDiscount" filterable>
        <Option v-for="item in filterDiscount" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <p>状态：</p>
      <Select v-model="addStatus" filterable>
        <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
      <!-- <Checkbox v-model="isUpdateTime">是否更新时间</Checkbox> -->
      <p>备注：用钻购买价格，-1为不可用钻购买；用币购买价格，-1为不可用币购买</p>
    </Modal>
	<Modal
	  v-model="modalTagAdd"
	  title="选择标签"
	  :closable="false"
	  :mask-closable="false"
	  @on-ok="updateTags"
	>
	  <p>款式标签：</p>
	  <Select v-model="updateTagsType" filterable>
	    <Option v-for="item in dataTypeTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
	  </Select>
	  <p>风格标签一：</p>
	  <Select v-model="updateTagsStyleFirst" filterable>
	    <Option v-for="item in dataStyleTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
	  </Select>
	  <p>风格标签二：</p>
	  <Select v-model="updateTagsStyleSeconds" filterable>
	    <Option v-for="item in dataStyleTags" :value="item.id" :key="item.id">{{ item.title }}</Option>
	  </Select>
	  <p>备注：款式标签必选一个,风格标签可选择0/1/2个</p>
	</Modal>
    <div class="headers">
      <span>分类：</span>
      <Select @on-change="changeSelect" v-model="classify" style="width: 80px">
        <Option
          v-for="item in filterClassify"
          :value="item.value"
          :key="item.value"
        >{{ item.label }}</Option>
      </Select>
      <span v-if="filterIds.length<=0" style="margin-left: 10px">性别：</span>
      <Select v-if="filterIds.length<=0" @on-change="changeSelect" v-model="sex" style="width: 80px">
        <Option
                v-for="item in filterSex"
                :value="item.value"
                :key="item.value"
        >{{ item.label }}</Option>
      </Select>
      <Button @click="modalAdd = true">新增</Button>
      <!-- <Button @click="sort_btn">{{sort_btn_msg}}</Button> -->
      <Button v-show="sortSaveBtn" @click="sort_save">保存</Button>
      <Button @click="getRecords">刷新</Button>
      <Input
        v-model="filterIds"
        placeholder="商品ID,逗号分隔"
        clearable
        style="min-width: 80px; width:150px; margin-left: 20px;"/>
      <Button @click="getRecords">搜索</Button>
    </div>
    <Table :columns="columns" :data="data">
		<template slot-scope="{ row, index }" slot="id">
		  <span>{{ row.id }}</span>
		</template>
		
		<template slot-scope="{ row, index }" slot="url">
		    <Poptip trigger="hover" :transfer="true" title="图片详情">
		        <div class="info-pop" slot="content">
		            <img :src="row.url" style="background-color: #f1e4b7;">
		        </div>
		        <img :src="row.url" style="background-color: #f1e4b7; width: 50px;height: 50px;">
		    </Poptip>
		</template>
      <template slot-scope="{ row, index }" slot="priority">
        <span>{{ row.priority }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="category_id">
        <template v-if="editIndex === index">
          <Select v-model="updateClassify" filterable>
            <Option v-for="item in filterClassify" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.category_id|getClassify }}</span>
      </template>

   <!--   <template slot-scope="{ row, index }" slot="images">
        <template v-if="editIndex === index"> -->
<!--          <i-Input v-model="updateImages" />-->
        <!--  <Input type="textarea" :autosize="{minRows: 3}" v-model="updateImages" placeholder="请输入图片名称，回车输入下一个" clearable/>
        </template>
        <span class="images-text" v-else>{{ row.images }}</span>
      </template> -->

      <template slot-scope="{ row, index }" slot="sex">
        <template v-if="editIndex === index">
          <Select v-model="updateSex" filterable>
            <Option v-for="item in filterSex.slice(0,2)" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.sex|getSex }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="jewel_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateJewelPrice" />
        </template>
        <span v-else>{{ row.jewel_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="coin_price">
        <template v-if="editIndex === index">
          <i-Input v-model="updateCoinPrice" />
        </template>
        <span v-else>{{ row.coin_price }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="discount">
        <template v-if="editIndex === index">
          <Select v-model="updateDiscount" filterable>
            <Option v-for="item in filterDiscount" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.discount|getDiscount }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="status">
        <template v-if="editIndex === index">
          <Select v-model="updateStatus" filterable>
            <Option v-for="item in filterStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <span v-else>{{ row.status|getStatus }}</span>
      </template>
	  
	  <template slot-scope="{ row, index }" slot="tags">
	    <span class="images-text">{{ row.tags|getTags }}</span>
	  </template>

      <template slot-scope="{ row, index }" slot="action">
        <div v-if="!sorting">
          <div v-if="editIndex === index">
            <Button @click="handleSave(index)" :disabled="action_btn_disabled">保存</Button>
            <Button
              style="margin-left: 10px"
              @click="editIndex = -1"
              :disabled="action_btn_disabled"
            >取消</Button>
          </div>
          <div v-else>
			<Button @click="handleToTop(row, index)">置顶</Button>
            <!-- <Button @click="handleEdit(row, index)">修改</Button>
			<Button st yle="margin-left: 10px" @click="showSelectTags(row, index)">标签</Button> -->
            <!-- <Button style="margin-left: 10px" @click="deleteRecord(row, index)">删除</Button> -->
          </div>
        </div>
        <div v-else>
          <Button
            :disabled="index === 0"
            style="border-radius: 50%"
            @click="handel_sort(row,index,'up')"
          >上</Button>
          <Button
            :disabled="index === data.length -1"
            style="border-radius: 50%;margin-left: 5px"
            @click="handel_sort(row,index,'down')"
          >下</Button>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import apis from "../../http/api";
import OSS from 'ali-oss';

export default {
  name: "faq",
  data() {
    return {
      filterIds: "",
	  ossClient: null,
	  shop_image_name: null,
	  shop_image_data: null,
	  stand_image_name: null,
	  stand_image_data: null,
	  sit_image_name: null,
	  sit_image_data: null,
	  lie_self_image_name: null,
	  lie_self_image_data: null,
	  lie_front_image_name: null,
	  lie_front_image_data: null,
	  
      filterDiscount: [{ label: '可打折', value: 1 }, { label: '不可打折', value: 0 }],
      filterStatus: [{ label: '正常', value: 0 }, { label: '下架', value: -1 }, { label: '赠品', value: -2 }],
      filterClassify: [{ label: '表情', value: 1 }, { label: '刘海', value: 2 }, { label: '发型', value: 3 },
        { label: '上装', value: 4 }, { label: '下装', value: 5 }, { label: '袜子', value: 6 },
        { label: '鞋子', value: 7 }, { label: '头饰', value: 8 }, { label: '耳环', value: 9 },
		{ label: '脸部饰品', value: 10 }, { label: '项链', value: 11 }],
      classify: 1,
      filterSex: [{ label: '女', value: 0 }, { label: '男', value: 1 }, { label: '全部', value: -1 }],
      sex: 0,   // 0女，1男，-1全部
      data: [],
      tmpData: [],
      modalAdd: false,
      action_btn_disabled: false,
      sortSaveBtn: false,
      update_question: "",
      update_answer: "",
      update_faq_id: null,
      editIndex: -1,
      sorting: false,
      sortBtnDesc: "排序",
      addClassify: 1,
      addImages: "",
      addSex: 0,
      addDiscount: 0,
      addJewelPrice: null,
      addCoinPrice: null,
      addStatus: 0,
      updateClassify:'',
      updateImages: "",
      updateSex: 0,
      updateDiscount: 0,
      updateJewelPrice: null,
      updateCoinPrice: null,
      updateStatus: 0,
	  modalTagAdd: false,
	  updateTagsIndex: -1,
	  dataTypeTags: [],
	  dataStyleTags: [],
	  updateTagsPropId: -1,
	  updateTagsType: 0,
	  updateTagsStyleFirst: 0,
	  updateTagsStyleSeconds: 0,
	  updateTagsArray:[],
      columns: [
		  {
		    title: 'ID',
		    slot: 'id',
		    width: 80
		  },
		  {
		    title: '缩略图',
		    slot: 'url',
		    width: 0
		  },
        {
          title: '优先级',
          slot: 'priority',
          width: 80
        },
        {
          title: '类型',
          slot: 'category_id',
          // width: 120
        },
        // {
        //   title: '图片',
        //   slot: 'images',
        //   width: 220
        // },
        {
          title: '性别',
          slot: 'sex',
          // width: 170
        },
        {
          title: '用钻价格',
          slot: 'jewel_price',
          // width: 170
        },
        {
          title: '用币价格',
          slot: 'coin_price',
          // width: 170
        },
        {
          title: '折扣',
          slot: 'discount',
          // width: 170
        },
        {
          title: '状态',
          slot: 'status',
          // width: 170
        },
		{
		  title: '标签',
		  slot: 'tags',
		  width: 0
		},
        {
          title: '操作',
          slot: 'action',
          width: 180
        }
      ]
    }
  },
  async created() {
	this.getOss();
    await this.getRecords()
  },
  watch: {
    // 如果退出编辑将多选框置为false
    editIndex: function (newVal, oldVal) {
      if (newVal === -1) {
        this.isUpdateTime = false
      }
    },
    modalAdd: function (newVal, oldVal) {
      if (newVal) {
        this.addClassify = this.classify;
        this.addSex = this.sex !== -1 ? this.sex : 1
      }
    },
	modalTagAdd: function (newVal, oldVal) {
	  if (newVal) {
	  }
	}
  },
  methods: {
	async getOss() {
	    apis.get_oss().then(res => {
	        this.ossClient = new OSS({
	            region: 'oss-cn-shanghai',
	            accessKeyId: res.AccessKeyId,
	            accessKeySecret: res.AccessKeySecret,
	            stsToken: res.SecurityToken,
	            bucket: 'co-study',
	        })
	    }).catch(err => {
	        console.log(err)
	    })
	},
	addImageForShop(event) {
		return this.addImgRecord(event, 1)
	},
	addImageForStand(event) {
		return this.addImgRecord(event, 2)
	},
	addImageForSit(event) {
		return this.addImgRecord(event, 3)
	},
	addImageForLieSelf(event) {
		return this.addImgRecord(event, 4)
	},
	addImageForLieFront(event) {
		return this.addImgRecord(event, 5)
	},
	addImgRecord(event, type) {
	    try {
	        let ts = (new Date()).valueOf();
	        let filename = '.' + event.name.split('.').pop();
	        if(filename !== '.png'){
	            this.$Message.error('仅支持上传png格式的图片');
	            return Promise.reject()
	        }
			let timestamp = Date.now()
			timestamp =  parseInt(timestamp/1000)
			
			let min = 1000
			let max = 9999
			parseInt(Math.random()*(max-min+1)+min,10);
			let random = Math.floor(Math.random()*(max-min+1)+min);
			
			filename = 1 +'_'+ timestamp+'_' + random + '.png'
			console.log(filename)
	        if (this.classify === null) {
	            this.$Message.error('请先选择类型');
	            return Promise.reject()
	        }
			if (type === 1){
				this.shop_image_name = filename
				this.shop_image_data = event
			}else if (type === 2){
				this.stand_image_name = filename
				this.stand_image_data = event
			}else if (type === 3){
				this.sit_image_name = filename
				this.sit_image_data = event
			}else if (type === 4){
				this.lie_self_image_name = filename
				this.lie_self_image_data = event
			}else if (type === 5){
				this.lie_front_image_name = filename
				this.lie_front_image_data = event
			}
	   //      let result = await this.ossClient.put(this.shop_image_name, this.shop_image_data);
	   //      if (result.res.status === 200) {
				// this.$Message.success('上传成功');
	   //      } else {
	   //          console.log(result)
	   //          this.$Message.error('上传至oss失败');
	   //      }
	    } catch (e) {
	        console.log(e);
	        this.$Message.error('上传至oss失败');
	    }
	    return Promise.reject()
	},
	async upload_image_to_oss(){
		let oss_url = 'app/image/figure/new_part/'
		if (this.sex === 1) {
			oss_url = oss_url + 'boy/'
		}else {
			oss_url = oss_url + 'girl/'
		}
		let result = await this.ossClient.put(oss_url + this.shop_image_name, this.shop_image_data);
		if (result.res.status === 200) {
			// this.$Message.success('上传成功');
		} else {
		    return false
		}
		result = await this.ossClient.put(oss_url + this.stand_image_name, this.stand_image_data);
		if (result.res.status === 200) {
			// this.$Message.success('上传成功');
		} else {
		    return false
		}
		result = await this.ossClient.put(oss_url + this.sit_image_name, this.sit_image_data);
		if (result.res.status === 200) {
			// this.$Message.success('上传成功');
		} else {
		    return false
		}
		result = await this.ossClient.put(oss_url + this.lie_self_image_name, this.lie_self_image_data);
		if (result.res.status === 200) {
			// this.$Message.success('上传成功');
		} else {
		    return false
		}
		result = await this.ossClient.put(oss_url + this.lie_front_image_name, this.lie_front_image_data);
		if (result.res.status === 200) {
			// this.$Message.success('上传成功');
		} else {
		    return false
		}
		return true
	},
    async getRecords() {
      if(this.filterIds == undefined){
          this.filterIds = ""
      }
      let params = {
        'category_id': this.classify,
        'sex': this.sex,
        'figure_image_ids': this.filterIds
      }
      apis.image_shop_all_records(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.data = data.records
        }
      }).catch(err => {

      })
    },
	showSelectTags(row, index){
	  this.updateTagsPropId = row.id
	  this.updateTagsType = 0
	  this.updateTagsStyleFirst = 0
	  this.updateTagsStyleSeconds = 0
	  this.modalTagAdd = false
	  this.dataStyleTags = []
	  this.dataTypeTags = []
	  this.updateTagsArray = row.tags.split(/[\s\n]/)
	  this.updateTagsIndex = index
      this.getClothesTags(row.sex)
	},
	getClothesTags(prop_sex) {
	  let params = {
		'category_ids': this.classify,
		'sex': prop_sex,
	  }
	  apis.figure_shop_get_clothes_tags(params).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode === 0) {
		  data.style_tags.unshift({'id': 0,'title': '空'})
		  this.dataTypeTags = data.type_tags
		  this.dataStyleTags = data.style_tags
		  let hasType = false
		  this.updateTagsArray.forEach(record => {
		    if (typeof (record) === 'string' && record.length > 0) {
			  this.dataTypeTags.forEach(item => {
			    if (typeof (item.title) === 'string' && item.title.length > 0 && record === item.title) {
			  		if(this.updateTagsType === 0){
						this.updateTagsType = item.id
						hasType = true
						return false
					}
			    }
			  });
			  if(hasType === true){
				this.dataStyleTags.forEach(item => {
				  if (typeof (item.title) === 'string' && item.title.length > 0 && record === item.title) {
						if(this.updateTagsStyleFirst === 0){
							this.updateTagsStyleFirst = item.id
						}else if(this.updateTagsStyleSeconds === 0){
							this.updateTagsStyleSeconds = item.id
						}
				  }
				});  
			  }
		    }
		  });
		  this.modalTagAdd = true
	    }else{
		  this.$Message.error('获取标签列表失败');
		}
	  }).catch(err => {
		this.$Message.error('获取标签列表失败');
	  })
	},
	updateTags() {
	  console.log("test info updateTagsPropId :  "+this.updateTagsPropId)
	  console.log("test info updateTagsIndex :  "+this.updateTagsIndex)
	  if (!this.updateTagsPropId>0) {
	    this.$Message.error('请选择商品!');
	    return
	  }		
	  if (this.updateTagsIndex<0) {
	    this.$Message.error('请选择商品');
	    return
	  }
	  if (!this.updateTagsType>0) {
	    this.$Message.error('款式标签不能为空');
	    return
	  }
	  if (this.updateTagsStyleFirst!=0 && this.updateTagsStyleSeconds!=0 && this.updateTagsStyleFirst === this.updateTagsStyleSeconds) {
	    this.$Message.error('风格标签一和风格标签二不能一样！');
	    return
	  }
	  let styleTagIds = ""
	  if(this.updateTagsStyleFirst === 0 && this.updateTagsStyleSeconds === 0){
		  
	  }else if(this.updateTagsStyleFirst === 0 || this.updateTagsStyleSeconds === 0){
		styleTagIds = this.updateTagsStyleFirst == 0 ? ""+this.updateTagsStyleSeconds : ""+this.updateTagsStyleFirst
	  }else{
		styleTagIds = this.updateTagsStyleFirst+","+this.updateTagsStyleSeconds 
	  }
	  console.log("test info styleIds :  "+styleTagIds)
	  let post_data = {
	    figure_image_id: this.updateTagsPropId,
	    type_tag_id: this.updateTagsType,
	   	style_tag_ids: styleTagIds,
	  }
	  apis.figure_shop_post_clothes_bind_tag(post_data).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode !== 0){
		  console.log("test info error :  "+msg)
	      this.$Message.error(msg);
	    }
	    this.getRecords()
	  })
	},
    async addRecord() {
	  if (!this.shop_image_name || !this.stand_image_name || !this.sit_image_name || !this.lie_front_image_name || !this.lie_self_image_name) {
	    this.$Message.error('图片不能为空');
	    return
	  }
      if (!this.addJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.addCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
	  let upload_result = await this.upload_image_to_oss()
	  if (!upload_result) {
		  this.$Message.error('图片上传失败');
		  return
	  }else{
		  this.$Message.error('图片上传成功');
	  }
	  let prefix_url = ''
	  if (this.sex === 1) {
		  prefix_url = 'boy/'
	  }else {
		  prefix_url = 'girl/'
	  }
	  var images_dict = {
		  'shop':prefix_url+this.shop_image_name,
		  'stand':prefix_url+this.stand_image_name,
		  'sit':prefix_url+this.sit_image_name,
		  'lie_self':prefix_url+this.lie_self_image_name,
		  'lie_front':prefix_url+this.lie_front_image_name
	  }
	  console.log(images_dict)
	  this.addImages = JSON.stringify(images_dict)
      let post_data = {
        category_id: this.addClassify,
        sex: this.addSex,
        images: this.addImages,
        jewel_price: this.addJewelPrice,
        coin_price: this.addCoinPrice,
        discount: this.addDiscount,
        status: this.addStatus,
		shop_id: 1,
      }
	  console.log(post_data)
      await apis.image_shop_upload(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.addImages = ""
          this.addJewelPrice = null
          this.addCoinPrice = null
		  this.shop_image_name = null
		  this.shop_image_data = null
		  this.stand_image_name = null
		  this.stand_image_data = null
		  this.sit_image_name = null
		  this.sit_image_data = null
		  this.lie_self_image_name = null
		  this.lie_self_image_data = null
		  this.lie_front_image_name = null
		  this.lie_front_image_data = null
        }else {
          this.$Message.error(msg);
        }
      }).catch(res => {
        this.$Message.error(res.toString());
      })

      await this.getRecords()
    },
    updateRecord(index) {
      if (!this.updateImages) {
        this.$Message.error('图片不能为空');
        return
      }
      if (!this.updateJewelPrice) {
        this.$Message.error('钻价格不能为空');
        return
      }
      if (!this.updateCoinPrice) {
        this.$Message.error('币价格不能为空');
        return
      }
      let post_data = {
        id: this.data[index].id,
        category_id: this.updateClassify,
        sex: this.updateSex,
        images: this.updateImages,
        jewel_price: this.updateJewelPrice,
        coin_price: this.updateCoinPrice,
        discount: this.updateDiscount,
        status: this.updateStatus,
      }
      apis.image_shop_update_record(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode !== 0){
          this.$Message.error(msg);
        }
        this.getRecords()
      })
    },
	figureImageSortToTop(index) {
	 
	  let post_data = {
	    figure_image_id: this.data[index].id,
	  }
	  apis.image_shop_sort_top(post_data).then(res => {
	    const { data, errCode, msg } = res;
	    if (errCode !== 0){
	      this.$Message.error(msg);
	    }
	    this.getRecords()
	  })
	},
    // deleteRecord(row, index) {
    //   this.data.splice(index, 1)
    //   let post_data = {
    //     id: row.id,
    //     classify: this.classify,
    //     records: this.data
    //   }
    //   apis.faq_delete_record(post_data).then(res => {
    //     const { data, errCode, msg } = res;
    //     if (errCode === 0) {
    //       this.refreshRecords()
    //     }
    //   }).catch()
    // },
    handleEdit(row, index) {
      this.action_btn_disabled = false;
      this.updateClassify = row.category_id;
      console.log(row.classify);
      this.updateImages = row.images;
      this.updateSex = row.sex;
      console.log(row.sex)
      this.updateDiscount = row.discount;
      this.updateJewelPrice = row.jewel_price;
      this.updateCoinPrice = row.coin_price;
      this.updateStatus = row.status;
      console.log(row.status)
      this.editIndex = index;
    },
    handleSave(index) {
      this.action_btn_disabled = true;
      this.updateRecord(index);
      this.editIndex = -1;
    },
    sort_btn() {
      if(this.sex === -1){
        this.$Message.warning('全部性别下不可排序');
        return
      }
      this.sorting = !this.sorting
      this.sortSaveBtn = !this.sortSaveBtn
      if (!this.sorting) {
        // 深拷贝
        let tmp = JSON.stringify(this.tmpData)
        this.data = JSON.parse(tmp)
      } else {
        // 深拷贝
        let tmp = JSON.stringify(this.data)
        this.tmpData = JSON.parse(tmp)
      }
    },
    handel_sort(row, index, action) {
      let index2 = action === "up" ? index - 1 : index + 1;
      let index1 = index;
      // 将当前位置的值取出来替换为另一个值并将当前取出来的值赋给另一个值
      this.data[index1] = this.data.splice(index2, 1, this.data[index1])[0]
    },
    sort_save() {
      this.sorting = !this.sorting
      this.sortSaveBtn = !this.sortSaveBtn
      let post_data = {
        records: this.data,
        classify: this.classify,
        sex: this.sex
      }
      apis.image_shop_sort_records(post_data).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.getRecords()
        }
      })
    },
    async changeSelect() {
      await this.getRecords()
    },
	handleToTop(row, index) {
	  this.figureImageSortToTop(index);
	}
  },
  computed: {
    sort_btn_msg() {
      return this.sorting ? "取消" : "排序"
    }
  },
  filters:{
    getClassify(val){
      let categoryClassifyMap = {1: '表情', 2: '刘海', 3: '发型', 4: '上装', 5: '下装', 6: '袜子', 7: '鞋子', 8: '配饰'}
      return categoryClassifyMap[val]
    },
    getSex(val){
      if(val === 0) {
        return '女'
      }else {
        return '男'
      }
    },
    getDiscount(val){
      if (val > 0){
        return '可打折'
      }else {
        return '不可打折'
      }
    },
    getStatus(val) {
      if(val === 0){
        return '正常'
      }else if(val === -1){
        return '下架'
      } else if(val === -2){
        return '赠品'
      } else {
        return '异常'
      }
    },
	getTags(val) {
	  if(val === ""){
	    return '暂无'
	  }else {
	    return val
	  }
	}
  }
}
</script>

<style lang="stylus" scoped>
.faq /deep/ .ivu-table-cell {
  min-height: 33px;
  display: flex;
  justify-content center;
  align-items: center;
}

.faq {
  margin: 10px;
}

.headers {
  text-align: center;
  margin-bottom: 10px;
}

.headers button {
  margin-left: 10px;
}

.images-text {
  white-space: pre-wrap;
}

</style>